document.addEventListener("DOMContentLoaded", function () {

  const invalidChars = /[{}%*]/;

  const forms = document.querySelectorAll("form");

  forms.forEach(form => {

    // 🚫 BLOCK ALL SUBMISSION (submit, JS, AJAX)
    form.addEventListener("submit", function (e) {
      if (!validateForm(form)) {
        console.log("⛔ Submission blocked");
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true); // 👈 VERY IMPORTANT — run before theme JS

  });

  // ✅ now validateForm() is available to ALL listeners
  function validateForm(form) {
    let hasError = false;

    let errorMsg = form.querySelector("#form-error");
    if (!errorMsg) {
      errorMsg = document.createElement("div");
      errorMsg.id = "form-error";
      errorMsg.style.color = "red";
      errorMsg.style.marginBottom = "10px";
      form.prepend(errorMsg);
    }

    const inputs = form.querySelectorAll("input[type=text], input[type=email], textarea");

    inputs.forEach(input => {
      if (invalidChars.test(input.value)) {
        hasError = true;
        input.classList.add("input-error");
      } else {
        input.classList.remove("input-error");
      }
    });

    if (hasError) {
      errorMsg.innerText =
        "Special characters like { } % * are not allowed. Please remove them and try again.";
    } else {
      errorMsg.innerText = "";
    }

    return !hasError;
  }

  // 🚫 ALSO BLOCK BUTTON CLICKS THAT TRY TO BYPASS FORM SUBMIT
  document.addEventListener("click", function (e) {
    if (e.target.matches("[type=submit], .button, .btn")) {
      const form = e.target.closest("form");
      if (form && !validateForm(form)) {
        console.log("⛔ Button click blocked");
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }
  }, true); // also capture click early

});
